import React from 'react';
import DOMPurify from 'isomorphic-dompurify';

interface ArticleIntroProps {
    introContent?: string;
    lastUpdatedDate?: string;
    introClassname?: string;
}

const formatDateToMMDDYYYY = (isoDate: string): string => {
    const date = new Date(isoDate);
    const month = String(date.getMonth() + 1).padStart(2, '0'); 
    const day = String(date.getDate()).padStart(2, '0');
    const year = date.getFullYear();
    return `${month}-${day}-${year}`;
};

const ArticleIntro: React.FC<ArticleIntroProps> = ({ introContent, lastUpdatedDate, introClassname }) => {
    const lastUpdated = lastUpdatedDate
        ? formatDateToMMDDYYYY(lastUpdatedDate)
        : '';
    const getHelp = introClassname === 'article-get-help-intro';


    return (
        <div className={`${introClassname || 'article-introduction'} py-2`}>
            <p className='font-semi-bold text-base px-1h md:px-0 pt-1h'>{lastUpdated}</p>
            <p
                className={getHelp ? 'article-get-help-intro' : 'article-intro'}
                dangerouslySetInnerHTML={{
                    __html: DOMPurify.sanitize((introContent || ''))
                }}
            />
        </div>
    );
};

export default ArticleIntro;